import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import { Sidebar } from '../moderator/Sidebar';
import { Navbar } from "../Navbar";

export default function AddExpense() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  const [expenseType, setExpenseType] = useState([]);
  const [formData, setFormData] = useState({
    expenseType: "",
    expenseHead: "",
    buyerName: "",
    rate: "",
    quantity: "",
    total: "0",
    payment_method: "Cash",
    bank_name: "",
    cheque_no: "",
    transaction_id: ""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 1. Fetch Expense Categories
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/expense/expense-type`, {
          method: 'GET',
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' 
          }
        });
        const data = await response.json();
        setExpenseType(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to fetch expense types", error);
      }
    };
    if (token) fetchData();
  }, [token]);

  // 2. Handle Input Changes & Auto-Calculate Total
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      
      if (name === "rate" || name === "quantity") {
        const r = name === "rate" ? value : prevData.rate;
        const q = name === "quantity" ? value : prevData.quantity;
        updatedData.total = (Number(r) * Number(q)).toString();
      }
      
      return updatedData;
    });
  };

  // 3. Form Validation Logic
  const validateForm = () => {
    const newErrors = {};
    if (!formData.expenseType) newErrors.expenseType = "Required";
    if (!formData.expenseHead) newErrors.expenseHead = "Required";
    if (!formData.rate || Number(formData.rate) <= 0) newErrors.rate = "Invalid rate";
    if (!formData.quantity || Number(formData.quantity) <= 0) newErrors.quantity = "Invalid qty";
    
    if (formData.payment_method === 'Cheque') {
      if (!formData.bank_name) newErrors.bank_name = "Bank Name Required";
      if (!formData.cheque_no) newErrors.cheque_no = "Cheque No Required";
    }
    if (formData.payment_method === 'Online' && !formData.transaction_id) {
      newErrors.transaction_id = "TID Required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 4. Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!userId) return alert("User Session Expired!");

    setIsSubmitting(true);
    const payload = { 
      ...formData, 
      user_id: parseInt(userId),
      // Sirf relevant fields bhejein
      bank_name: formData.payment_method === 'Cheque' ? formData.bank_name : null,
      cheque_no: formData.payment_method === 'Cheque' ? formData.cheque_no : null,
      transaction_id: formData.payment_method === 'Online' ? formData.transaction_id : null
    };

    try {
      const response = await fetch(`${config.baseUrl}/api/expense/addexpense`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        navigate("/expense/view-expense");
      } else {
        const errorData = await response.json();
        alert(errorData.message || "Failed to add expense.");
      }
    } catch (error) {
      alert("Network Error: Failed to add expense.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (   
      <div className="p-2">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 flex">
            <h1 className="text-2xl font-bold  text-indigo-800 border-l-4 border-indigo-600 pl-3">Add New Expense</h1>
                      </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
            <form onSubmit={handleSubmit} className="p-8 space-y-8">
              
              {/* Section 1: Basic Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Expense Category *</label>
                  <select
                    name="expenseType"
                    value={formData.expenseType}
                    onChange={handleInputChange}
                    className={`w-full border rounded-xl p-3 focus:ring-2 focus:ring-blue-500 outline-none transition-all ${errors.expenseType ? 'border-red-500' : 'border-gray-300'}`}
                  >
                    <option value="">Select Category</option>
                    {expenseType.map((type) => (
                      <option key={type.id} value={type.id}>{type.category_name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Description / Head *</label>
                  <input
                    type="text"
                    name="expenseHead"
                    value={formData.expenseHead}
                    onChange={handleInputChange}
                    className={`w-full border rounded-xl p-3 focus:ring-2 focus:ring-blue-500 outline-none ${errors.expenseHead ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="e.g. Office Stationery"
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Buyer / Payer Name</label>
                  <input
                    type="text"
                    name="buyerName"
                    value={formData.buyerName}
                    onChange={handleInputChange}
                    className="w-full border border-gray-300 rounded-xl p-3 outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Name of person"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">Rate (Rs.)</label>
                    <input
                      type="number"
                      name="rate"
                      value={formData.rate}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-xl p-3 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">Quantity</label>
                    <input
                      type="number"
                      name="quantity"
                      value={formData.quantity}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-xl p-3 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* Section 2: Payment Details */}
              <div className="bg-indigo-50/50 p-6 rounded-2xl border border-indigo-100">
                <h3 className="text-xs font-black text-indigo-900 uppercase tracking-widest mb-4">Payment Method & Settlement</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-end">
                  <div>
                    <div className="flex bg-white p-1.5 rounded-xl border border-gray-200 gap-1">
                      {['Cash', 'Cheque', 'Online'].map(mode => (
                        <button
                          key={mode}
                          type="button"
                          onClick={() => setFormData({...formData, payment_method: mode})}
                          className={`flex-1 py-2.5 rounded-lg text-sm font-bold transition-all ${formData.payment_method === mode ? 'bg-indigo-800 text-white shadow-lg' : 'bg-transparent text-gray-400 hover:bg-gray-50'}`}
                        >
                          {mode}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="text-right">
                    <p className="text-xs font-bold text-gray-400 uppercase mb-1">Total Payable</p>
                    <h2 className="text-3xl font-black text-indigo-900 leading-none">Rs. {formData.total}</h2>
                  </div>

                  {/* Dynamic Input Fields */}
                  {formData.payment_method === 'Cheque' && (
                    <div className="col-span-2 grid grid-cols-2 gap-4">
                      <div>
                        <input
                          type="text"
                          name="bank_name"
                          placeholder="Bank Name"
                          value={formData.bank_name}
                          onChange={handleInputChange}
                          className={`w-full border rounded-xl p-3 outline-none ${errors.bank_name ? 'border-red-500' : 'border-gray-300'}`}
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          name="cheque_no"
                          placeholder="Cheque Number"
                          value={formData.cheque_no}
                          onChange={handleInputChange}
                          className={`w-full border rounded-xl p-3 outline-none ${errors.cheque_no ? 'border-red-500' : 'border-gray-300'}`}
                        />
                      </div>
                    </div>
                  )}

                  {formData.payment_method === 'Online' && (
                    <div className="col-span-2">
                      <input
                        type="text"
                        name="transaction_id"
                        placeholder="Transaction ID / Reference Number"
                        value={formData.transaction_id}
                        onChange={handleInputChange}
                        className={`w-full border rounded-xl p-3 outline-none ${errors.transaction_id ? 'border-red-500' : 'border-gray-300'}`}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 pt-6 border-t border-gray-100">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`bg-indigo-800 text-white px-10 py-3.5 rounded-xl font-bold hover:bg-indigo-700 transition-all shadow-xl active:scale-95 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {isSubmitting ? 'Saving...' : 'Save Expense'}
                </button>
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="bg-gray-100 text-gray-600 px-10 py-3.5 rounded-xl font-bold hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
  
  );
}